export default __webpack_public_path__ + "static/media/program_1.96ab61e2.png";